import { 
  Alert,
  Box, 
  Button, 
  Grow, 
  InputAdornment, 
  MenuItem, 
  Select, 
  TextField, 
  Typography 
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/id";
import dayjs from "dayjs";

const ReservationForm = ({ 
  type, 
  onBack,
  formik,
  outlets,
  pickValue,
  setPickValue,  
}) => {
  return (
    <Grow in>
      <Box width={{ xs: "100vw", md: "45em" }}>
        {/* Title */}
        <Typography variant="h6" textAlign="center">
          {type === "dinein"
            ? "Form Reservasi Dine In / Bukber"
            : "Form Reservasi Catering"}
        </Typography>

        <Typography fontSize=".75em" color="GrayText" textAlign="center" my={1}>
          {type === "dinein"
            ? "Silakan isi data berikut untuk reservasi dine in."
            : "Silakan isi data berikut untuk reservasi catering."}
        </Typography>
        {/* End Title */}

        {/* Button Back Jenis Reservasi */}
        <Box display="flex" justifyContent="flex-start" px={2}>
          <Button size="small" onClick={onBack}>
            ← Ganti Jenis Reservasi
          </Button>
        </Box>
        {/* End Button Back Jenis Reservasi */}       

        {/* Form */}
        <Box>         
          <form 
            autoComplete="off" 
            onSubmit={formik.handleSubmit}
          >
            <Box
              sx={{
                width: { xs: "100vw", sm: "23em", md: "23em", lg: "45em" },
                display: "flex",
                flexDirection: "column",
                my: 3,
                px: 2,
              }}
            >
              {/* Nama customer */}
              <Typography
                sx={{
                  fontSize: ".8em",
                  fontWeight: 500,
                  textTransform: "capitalize",
                  marginBottom: ".2em",
                  color: "grey",
                }}
              >
                Nama Lengkap :
              </Typography>
              <TextField
                required
                fullWidth
                id="order_person"
                variant="outlined"
                size="small"
                color="primary"
                value={formik.values.order_person}
                onChange={formik.handleChange}
                InputLabelProps={{ style: { color: "#4F7170" } }}
              />

              {/* Nomor Handphone */}
              <Typography
                sx={{
                  fontSize: ".8em",
                  fontWeight: 500,
                  textTransform: "capitalize",
                  marginBottom: ".2em",
                  marginTop: "1em",
                  color: "grey",
                }}
              >
                Nomor Handphone :
              </Typography>
              <TextField
                required
                variant="outlined"
                id="phone"
                size="small"
                color="primary"
                value={formik.values.phone}
                onChange={(e) => {
                  let value = e.target.value
                    .replace(/\D/g, "")   
                    .replace(/^0+/, "")   
                    .slice(0, 14);        

                  formik.setFieldValue(
                    "phone",
                    value === "" ? "" : Number(value)
                  );
                }}
                inputProps={{
                  maxLength: 14,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <font color="#4F7170">+62</font>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Khusus Bukber */}
              {type === "dinein" && (
                <>
                  {/* Jumlah Seat */}
                  <Typography
                    sx={{
                      fontSize: ".8em",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      marginBottom: ".2em",
                      marginTop: "1em",
                      color: "grey",
                    }}
                  >
                    Jumlah Orang :
                  </Typography>
                  <TextField
                    required
                    variant="outlined"
                    id="seat"
                    size="small"
                    color="primary"                    
                    value={formik.values.seat}
                    onChange={(e) => {
                      let value = e.target.value
                        .replace(/\D/g, "")   
                        .replace(/^0+/, "")   
                        .slice(0, 5);        

                      formik.setFieldValue(
                        "seat",
                        value === "" ? "" : Number(value)
                      );
                    }}
                    inputProps={{
                      maxLength: 5,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}                    
                  />              

                  {/* Outlet */}
                  <Typography
                    sx={{
                      fontSize: ".8em",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      marginBottom: ".2em",
                      marginTop: "1em",
                      color: "grey",
                    }}
                  >
                    Outlet :
                  </Typography>
                  <Select
                    // required
                    variant="outlined"
                    id="outletId"
                    size="small"
                    color="primary"
                    value={formik.values.outletId}
                    onChange={(e) => {
                      // setOutletId(e.target.value);
                      formik.setFieldValue("outletId", e.target.value);
                    }}
                  >
                    {outlets.map((outlet) => {
                      return (
                        <MenuItem value={parseInt(outlet.outlet_id)} key={outlet.id}>
                          <Typography
                            noWrap
                            sx={{
                              fontSize: ".8em",
                              fontWeight: 500,
                              textTransform: "capitalize",
                              width: "100%",
                              padding: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}                            
                          >
                            {outlet?.outlet} - {outlet?.address}
                          </Typography>
                        </MenuItem>
                      );
                    })}
                  </Select>
                            
                  {/* Tanggal */}
                  <Typography
                    sx={{
                      fontSize: ".8em",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      marginBottom: ".2em",
                      marginTop: "1em",
                      color: "grey",
                    }}
                  >
                    Tanggal reservasi :
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="id">
                    <DateTimePicker
                      id="order_date"
                      timeSteps={{ minutes: 30 }}
                      value={pickValue}
                      onChange={(newValue) => {
                        setPickValue(newValue);
                        formik.setFieldValue(
                          "order_date",
                          `${dayjs(newValue).format("YYYY-MM-DDTHH:mm:ss.SSSZ")}`
                        );
                      }}
                      minDate={dayjs()}
                    />
                  </LocalizationProvider>
                </>
              )} 

              {/* Khusus Catering */}
              {type === "catering" && (
                <>
                  {/* Jumlah Pack */}
                  <Typography
                    sx={{
                      fontSize: ".8em",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      marginBottom: ".2em",
                      marginTop: "1em",
                      color: "grey",
                    }}
                  >
                    Jumlah Pack :
                  </Typography>
                  <TextField
                    required
                    variant="outlined"
                    id="pack"
                    size="small"
                    color="primary"
                    type="number"
                    value={formik.values.pack}
                    onChange={(e) => {
                      let value = e.target.value
                        .replace(/\D/g, "")   
                        .replace(/^0+/, "")   
                        .slice(0, 4);        

                      formik.setFieldValue(
                        "pack",
                        value === "" ? "" : Number(value)
                      );
                    }}
                    inputProps={{
                      maxLength: 4,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}                    
                  />              

                  {/* Pengiriman */}
                  <Typography
                    sx={{
                      fontSize: ".8em",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      marginBottom: ".2em",
                      marginTop: "1em",
                      color: "grey",
                    }}
                  >
                    Alamat Pengiriman :
                  </Typography>
                  <TextField
                    required
                    variant="outlined"
                    id="address"
                    size="small"
                    color="primary"                    
                    multiline
                    minRows={2}
                    value={formik.values.address}
                    onChange={formik.handleChange}
                  />     
                            
                  {/* Tanggal */}
                  <Typography
                    sx={{
                      fontSize: ".8em",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      marginBottom: ".2em",
                      marginTop: "1em",
                      color: "grey",
                    }}
                  >
                    Tanggal Pengiriman :
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="id">
                    <DateTimePicker
                      id="order_date"
                      timeSteps={{ minutes: 30 }}
                      value={pickValue}
                      onChange={(newValue) => {
                        setPickValue(newValue);
                        formik.setFieldValue(
                          "order_date",
                          `${dayjs(newValue).format("YYYY-MM-DDTHH:mm:ss.SSSZ")}`
                        );
                      }}
                      minDate={dayjs()}
                    />
                  </LocalizationProvider>
                </>
              )} 
              
              <Button
                variant="contained"
                color="success"                
                type="submit"   
                sx={{ mt: "1em" }}             
              >
                Reservasi
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Grow>
  );
};

export default ReservationForm;